// import axios, { AxiosError, AxiosPromise, AxiosProxyConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

// ------------- AXIOS DEFAULTS SETTINGS -------------
// ---------------------------------------------------
const defaultURL = 'http://35.181.211.12:31000/';

axios.defaults.baseURL = defaultURL;
